import { t } from "@lingui/macro";
import graphql from "babel-plugin-relay/macro";

import { useToast } from "@whoosh/design-system/src/components/overlay/Toast/useToast";

import { useMutationWithError } from "../../../utils/hooks/useMutationWithError";
import {
  usePasswordResetMutation,
  PasswordResetInput,
} from "./__generated__/usePasswordResetMutation.graphql";

export const usePasswordReset = ({
  onComplete,
}: {
  onComplete: () => void;
}) => {
  const [sendResetPassword, isSendingReset] =
    useMutationWithError<usePasswordResetMutation>(PasswordResetMutationString);

  const { showToast } = useToast();

  const resetPassword = (input: PasswordResetInput) => {
    const onCompleted = () => {
      showToast({
        description: t`Password reset successfully!`,
        semanticStyle: "success",
        toastId: "password-reset-success",
      });
      onComplete();
      return [];
    };

    sendResetPassword({
      variables: { input },
      onCompleted: (res) => {
        if (res.responsePayload?.success) {
          onCompleted();
        } else {
          showToast({
            description: t`Unable to reset password. Please try again.`,
            semanticStyle: "error",
            toastId: `pasword-reset-error`,
          });
        }
      },
      onErrorCustom() {
        showToast({
          description: t`Unable to reset password. Please try again.`,
          semanticStyle: "error",
          toastId: `pasword-reset-error`,
        });
      },
    });
  };

  return [resetPassword, isSendingReset] as const;
};

export const PasswordResetMutationString = graphql`
  mutation usePasswordResetMutation($input: PasswordResetInput!) {
    responsePayload: passwordReset(input: $input) {
      success
      errors {
        code

        message
        field
      }
    }
  }
`;
